import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPhone, faEnvelope} from '@fortawesome/free-solid-svg-icons';

const SignupServiceInfo = () => {
    const iconStyle = {
        marginRight: '.5rem',
    };

    return (
        <>
            <h2>Fragen zum Bewerbungsprozess?</h2>
            <p>
                Kontaktieren Sie uns <strong>werktags von 9:00 bis 17:00 Uhr</strong> via
                Telefon oder E-Mail.
            </p>
            <div>
                <a
                    className="anl_signup--telephone-number d-block"
                    href="tel:+4922167774683"
                >
                    <FontAwesomeIcon
                        icon={faPhone}
                        style={iconStyle}
                        fixedWidth
                    />
                    <span className="visually-hidden">
                        Erreichbar per Telefon mit der Nummer:
                    </span>
                    0221 677 746 83
                </a>
                <a
                    className="anl_signup--email d-block mt-2"
                    href="mailto:hilfe@wp-koenigin.de"
                >
                    <FontAwesomeIcon
                        icon={faEnvelope}
                        style={iconStyle}
                        fixedWidth
                    />
                    <span className="visually-hidden">
                        Oder per E-Mail mit der Adresse:
                    </span>
                    hilfe@wp-koenigin.de
                </a>
            </div>
        </>
    );
};

export default SignupServiceInfo;